import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import CanvasExpandedView from '../view/CanvasExpandedView';
import CanvasDefinitionTabState from './CanvasDefinitionTabState';

export default class CanvasDefinitionTabView extends BufferTabView<CanvasDefinitionTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    this.listenTo(this.model, 'change:versionApiId', () => this.render());
  }

  override render(): this {
    const canvasDefinitionId = this.model.get('canvasDefinitionId');
    const canvasVersionId = this.model.get('versionApiId');
    this.reactRoot = renderToDOM(
      <CanvasExpandedView
        canvasDefinitionId={canvasDefinitionId}
        canvasVersionId={canvasVersionId}
        key={canvasVersionId}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): BufferTabView<CanvasDefinitionTabState> {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

CanvasDefinitionTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
